import type { NotificationSettingsFrequency } from './notificationSettingsFrequency';
import type { NotificationSettingsTypeSettings } from './notificationSettingsTypeSettings';

export interface NotificationSettings {
  emailEnabled?: boolean;
  frequency?: NotificationSettingsFrequency;
  inAppEnabled?: boolean;
  pushEnabled?: boolean;
  /** @nullable */
  quietHoursEnd?: string | null;
  /** @nullable */
  quietHoursStart?: string | null;
  smsEnabled?: boolean;
  typeSettings?: NotificationSettingsTypeSettings;
  userId: string;
}
